const LOCKING_STATUSES = new Set(["TO_CONFIRM", "CONFIRMED"]);

export const getUnavailableReservationTableIds = (
  reservations,
  startValue,
  endValue,
  excludedReservationId = null
) => {
  const start = new Date(startValue);
  const end = new Date(endValue);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end <= start) {
    return new Set();
  }

  const excludedId = Number(excludedReservationId);
  const unavailable = new Set();

  (Array.isArray(reservations) ? reservations : []).forEach((reservation) => {
    if (Number(reservation?.id) === excludedId) return;
    if (!LOCKING_STATUSES.has(String(reservation?.status || "TO_CONFIRM").toUpperCase())) return;

    const existingStart = new Date(reservation?.startDate);
    const existingEnd = new Date(reservation?.endDate);
    if (Number.isNaN(existingStart.getTime()) || Number.isNaN(existingEnd.getTime())) return;
    if (!(start < existingEnd && end > existingStart)) return;

    (Array.isArray(reservation?.tableReservations) ? reservation.tableReservations : [])
      .forEach((link) => {
        const tableId = Number(link?.tableId ?? link?.table?.id);
        if (Number.isInteger(tableId) && tableId > 0) unavailable.add(tableId);
      });
  });

  return unavailable;
};
